import React from 'react';
import { Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';
import { Text } from '@/components/Typography';
import { FolderSearchIcon } from '@/assets/icons/folder-search-icon';

interface EmptyProps {
	message?: string;
}

export function Empty({ message }: Readonly<EmptyProps>): JSX.Element {
	return (
		<Row gutter={[0, 10]}>
			<S.IconWrapper span={24}>
				<FolderSearchIcon />
			</S.IconWrapper>
			<S.TextWrapper span={24}>
				<Text>{message || I18n.get('No data available.')}</Text>
			</S.TextWrapper>
		</Row>
	);
}
